<template>
    <div class="modal fade" :id="'popUpSchedaAttivita'+rs" role="dialog" data-bs-backdrop="false">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header bg-secondary text-white border-0">
                    <h5 class="modal-title">
                        <i class="ph-list-checks icon-modal-size me-2"></i>
                        <span class="me-2">Gestione Attività:</span>{{ filters.titoloConTipologia(progetto) }}
                    </h5>
                    <button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" data-bs-dismiss="modal">
                        <i class="ph-x icon-x-size"></i>
                    </button>
                </div>

                <div class="modal-body p-3">
                    <div class="card">
                        <div class="card-header d-flex justify-content-between align-items-center">
                            <h6 class="mb-0">Attività e Voci del Progetto</h6>
                            <button class="btn btn-primary btn-sm" v-if="$root.hasFunzionalita('ATTIVITA_CREA')" @click="creaAttivita">
                                <i class="ph-plus me-1"></i> Nuova Attività
                            </button>
                        </div>
                        <div class="card-body">
                            <div>
                                <!-- Albero Attività Draggable -->
                                <draggable tag="div" :list="arrayAttivita" handle=".drag-handle-attivita" @end="ordineAttivitaChanged">
                                    <div v-for="attivita in arrayAttivita" :key="attivita.ID_ATTIVITA" class="mb-3">
                                        <!-- Livello 1: Attività -->
                                        <div class="d-flex align-items-center justify-content-between p-3 bg-light rounded">
                                            <div class="d-flex align-items-center flex-grow-1">
                                                <i class="ph-dots-six-vertical drag-handle-attivita cursor-move me-2" title="Trascina per riordinare"></i>
                                                <div class="d-flex align-items-center cursor-pointer flex-grow-1" @click="toggleAttivita(attivita)">
                                                    <i :class="attivita.expanded ? 'ph-caret-down' : 'ph-caret-right'" class="me-2"></i>
                                                    <strong>{{ attivita.TITOLO }}</strong>
                                                    <span class="badge bg-secondary ms-2">{{ (attivita.VOCI || []).length }}</span>
                                                </div>
                                            </div>
                                            <div class="btn-group">
                                                <button class="btn btn-sm btn-success me-1" v-if="$root.hasFunzionalita('ATTIVITA_MODIFICA')" @click.stop="creaVoce(attivita)" title="Aggiungi voce">
                                                    <i class="ph-plus me-1"></i>
                                                    Nuova Voce
                                                </button>
                                                <button class="btn btn-sm btn-warning me-1" v-if="$root.hasFunzionalita('ATTIVITA_MODIFICA')" @click.stop="modificaAttivita(attivita)" title="Modifica attività">
                                                    <i class="ph-pencil"></i>
                                                </button>
                                                <button class="btn btn-sm btn-danger" v-if="$root.hasFunzionalita('ATTIVITA_ELIMINA')" @click.stop="eliminaAttivita(attivita)" title="Elimina attività">
                                                    <i class="ph-trash"></i>
                                                </button>
                                            </div>
                                        </div>

                                        <!-- Livello 2: Voci (espanse e draggable) -->
                                        <div v-if="attivita.expanded" class="ms-4 mt-2">
                                            <div v-if="!attivita.VOCI || attivita.VOCI.length == 0"
                                                 class="text-muted p-2">
                                                Nessuna voce per questa attività
                                            </div>
                                            <div v-else class="table-responsive">
                                                <table class="table table-sm table-hover mb-0">
                                                    <thead class="table-light">
                                                        <tr>
                                                            <th style="width: 5%"></th>
                                                            <th style="width: 30%">Titolo Voce</th>
                                                            <th style="width: 15%">Quantità</th>
                                                            <th style="width: 15%">Prezzo Unit.</th>
                                                            <th style="width: 15%">Totale</th>
                                                            <th style="width: 20%">Azioni</th>
                                                        </tr>
                                                    </thead>
                                                    <draggable tag="tbody" :list="attivita.VOCI" handle=".drag-handle-voce" @end="ordineVociChanged(attivita)">
                                                        <tr v-for="voce in attivita.VOCI" :key="voce.ID_VOCE">
                                                            <td>
                                                                <i class="ph-dots-six-vertical drag-handle-voce cursor-move" title="Trascina per riordinare"></i>
                                                            </td>
                                                            <td>
                                                                <i class="ph-file-text me-1 text-muted"></i>
                                                                {{ voce.TITOLO }}
                                                            </td>
                                                            <td>{{ voce.QUANTITY }}</td>
                                                            <td>{{ voce.UNIT_PRICE }} €</td>
                                                            <td class="fw-bold">{{ voce.TOTAL_PRICE }} €</td>
                                                            <td>
                                                                <button class="btn btn-sm btn-warning me-1" v-if="$root.hasFunzionalita('ATTIVITA_MODIFICA')"
                                                                        @click="modificaVoce(voce, attivita)"
                                                                        title="Modifica voce">
                                                                    <i class="ph-pencil"></i>
                                                                </button>
                                                                <button class="btn btn-sm btn-danger" v-if="$root.hasFunzionalita('ATTIVITA_ELIMINA')"
                                                                        @click="eliminaVoce(voce)"
                                                                        title="Elimina voce">
                                                                    <i class="ph-trash"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </draggable>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </draggable>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer bg-light p-1">
                    <button type="button" class="btn btn-link" data-bs-dismiss="modal">
                        <i class="fal fa-sign-out-alt fa-fw me-2"></i><Translate :path="'dizionario.base.BTN_CLOSE'"></Translate>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="popUpAttivita" role="dialog" data-bs-backdrop="false" style="z-index: 1070;">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <i class="ph-plus-circle me-2"></i>
                        {{ attivitaSelezionata.ID_ATTIVITA > 0 ? 'Modifica' : 'Nuova' }} Attività
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="mb-3">
                        <label class="form-label fw-semibold">Titolo Attività <span class="text-danger">*</span></label>
                        <input type="text"
                               class="form-control"
                               v-model="attivitaSelezionata.TITOLO"
                               placeholder="Inserisci il titolo dell'attività"
                               @keyup.enter="salvaAttivita">
                    </div>
                    <div class="mb-3">
                        <label class="form-label fw-semibold">Descrizione</label>
                        <textarea class="form-control"
                                  v-model="attivitaSelezionata.DESCRIZIONE"
                                  rows="3"
                                  placeholder="Descrizione opzionale dell'attività"></textarea>
                    </div>
                    <div class="mb-3">
                        <label class="form-label fw-semibold">Città</label>
                                       
                     </div>
                    <div class="alert alert-info mb-0">
                        <i class="ph-info me-2"></i>
                        Progetto: <strong>{{ filters.titoloConTipologia(progetto) }}</strong>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-link" data-bs-dismiss="modal">Annulla</button>
                    <button type="button"
                            class="btn btn-primary"
                            @click="salvaAttivita"
                            :disabled="!attivitaSelezionata.TITOLO">
                        <span>
                            <i class="ph-check me-1"></i>
                            Salva Attività
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal Nuova/Modifica Voce -->
    <div class="modal fade" id="popUpVoce" role="dialog" data-bs-backdrop="false" style="z-index: 1070;">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <i class="ph-plus-circle me-2"></i>
                        {{ voceSelezionata.ID_VOCE > 0 ? 'Modifica' : 'Nuova' }} Voce
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="alert alert-info mb-3">
                        <i class="ph-info me-2"></i>
                        Attività: <strong>{{ attivitaPerVoce.TITOLO }}</strong>
                    </div>

                    <div class="row">
                        <div class="col-md-12 mb-3">
                            <label class="form-label fw-semibold">Titolo Voce <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" v-model="voceSelezionata.TITOLO" placeholder="Inserisci il titolo della voce">
                        </div>
                    </div>

                    <div class="row mb-2">
                        <div class="col-md-3 mb-3">
                            <label class="form-label fw-semibold">Quantità</label>
                            <input type="number" step="1" min="1" class="form-control" v-model="voceSelezionata.QUANTITY" placeholder="1" @input="calcolaTotale">
                        </div>
                        <div class="col-md-3 mb-3">
                            <label class="form-label fw-semibold">Ripetizioni</label>
                            <input type="number" step="1" min="1" class="form-control" v-model="voceSelezionata.DAYS" placeholder="1" @input="calcolaTotale">
                        </div>
                    </div>

                    <h6 class="fw-semibold text-primary mb-2"><i class="ph-currency-circle-dollar me-1"></i>Vendita al cliente</h6>
                    <div class="row mb-2">
                        <div class="col-md-4 mb-3">
                            <label class="form-label fw-semibold">Costo <span class="text-danger">*</span></label>
                            <input type="number" step="0.01" class="form-control" v-model="voceSelezionata.UNIT_PRICE" placeholder="0.00" @input="calcolaTotale">
                        </div>
                        <div class="col-md-4 mb-3">
                            <label class="form-label fw-semibold">Totale Vendita</label>
                            <input type="number" step="0.01" class="form-control" v-model="voceSelezionata.TOTAL_PRICE" placeholder="0.00">
                        </div>
                    </div>

                    <div class="col-md-12 mb-3">
                        <label class="form-label fw-semibold">Note</label>
                        <textarea class="form-control" v-model="voceSelezionata.TESTO_NOTE" rows="3" placeholder="Note opzionali"></textarea>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-link" data-bs-dismiss="modal">Annulla</button>
                    <button type="button"
                            class="btn btn-primary"
                            @click="salvaVoce()"
                            :disabled="!voceSelezionata.TITOLO || !voceSelezionata.QUANTITY || !voceSelezionata.UNIT_PRICE || salvandoVoce">
                        <span v-if="salvandoVoce">
                            <span class="spinner-border spinner-border-sm me-1"></span>
                            Salvataggio...
                        </span>
                        <span v-else>
                            <i class="ph-check me-1"></i>
                            Salva Voce
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    

</template>

<script>
import { VueDraggableNext } from 'vue-draggable-next';


export default {
    name: "SchedaAttivita",
    emits: ['updateGriglia', 'updateProgetto'],
    components: {
        draggable: VueDraggableNext,

    },

    data: function() {
        return {
            filters: global.filters,
            progetto: {ID_PROGETTO: 0},
            rs: utils.generateRandomString(30),
            arrayAttivita: [],
            attivitaSelezionata: {},
            voceSelezionata: {},
            attivitaPerVoce: {},
            cittaProgetto: [],
            salvandoVoce: false,
        }
    },

    methods: {
        openSchedaAttivita: function(progetto) {
            this.progetto = utils.clone(progetto);
            this.getAttivita();
            this.filters.openPopUp('popUpSchedaAttivita' + this.rs);
        },

        getAttivita() {
            utils.ajax("theb/attivita", { ID_PROGETTO: this.progetto.ID_PROGETTO }, (response) => {
                this.arrayAttivita = (response.data || []).map(attivita => ({
                    ...attivita,
                    expanded: false,
                    VOCI: attivita.VOCI
                }));
            });
        },

        toggleAttivita(attivita) {
            attivita.expanded = !attivita.expanded;
        },

        creaAttivita() {
            this.attivitaSelezionata = {
                FK_ID_PROGETTO: this.progetto.ID_PROGETTO,
                ID_ATTIVITA: 0,
                TITOLO: '',
                DESCRIZIONE: ''
            };
            this.filters.openPopUp("popUpAttivita");
        },

        modificaAttivita(attivita) {
            this.attivitaSelezionata = utils.clone(attivita);
            this.getCittaProgetto();
            this.filters.openPopUp("popUpAttivita");
        },

        salvaAttivita() {
            const api = this.attivitaSelezionata.ID_ATTIVITA > 0 ? "theb/attivita/update" : "theb/attivita/insert";
            utils.ajax(api, this.attivitaSelezionata, (response) => {
                if (response.esito == 0) {
                    const msg = this.attivitaSelezionata.ID_ATTIVITA > 0 ? "aggiornata" : "creata";
                    utils.alert.success(`Attività ${msg} con successo.`);
                    this.getAttivita();
                    this.filters.closePopUp("popUpAttivita");
                    this.$emit('updateGriglia');
                }
            });
        },

        eliminaAttivita(attivita) {
            utils.alert.confirm(`Sei sicuro di voler eliminare l'attività "${attivita.TITOLO}"? Verranno eliminate anche tutte le voci associate.`, () => {
                utils.ajax("theb/attivita/delete", { ID_ATTIVITA: attivita.ID_ATTIVITA }, (response) => {
                    if (response.esito == 0) {
                        utils.alert.success("Attività eliminata con successo.");
                        this.getAttivita();
                        this.$emit('updateGriglia');
                    }
                });
            });
        },
        creaVoce(attivita) {
            this.attivitaPerVoce = attivita;
            this.voceSelezionata = {
                FK_ID_ATTIVITA: attivita.ID_ATTIVITA,
                FK_ID_PROGETTO: this.progetto.ID_PROGETTO,
                ID_VOCE: 0
            };
            this.filters.openPopUp("popUpVoce");
        },

        modificaVoce(voce, attivita) {
            this.attivitaPerVoce = attivita;
            this.voceSelezionata = utils.clone(voce);
            this.filters.openPopUp("popUpVoce");
        },

        calcolaTotale() {
            const qty = parseFloat(this.voceSelezionata.QUANTITY) || 0;
            const days = parseFloat(this.voceSelezionata.DAYS) || 1;
            const price = parseFloat(this.voceSelezionata.UNIT_PRICE) || 0;
            this.voceSelezionata.TOTAL_PRICE = (price * qty * days).toFixed(2);
        },

        salvaVoce() {
            this.salvandoVoce = true;
            var api = this.voceSelezionata.ID_VOCE > 0 ? "theb/voce/update" : "theb/voce/insert";
            utils.ajax(api, this.voceSelezionata, (response) => {
                this.salvandoVoce = false;
                if (response.esito == 0) {
                    const msg = this.voceSelezionata.ID_VOCE > 0 ? "aggiornata" : "creata";
                    utils.alert.success(`Voce ${msg} con successo.`);
                    this.getAttivita();
                    this.filters.closePopUp("popUpVoce");
                    this.$emit('updateGriglia');
                }
            });
        },

        eliminaVoce(voce) {
            utils.alert.confirm("Sei sicuro di voler eliminare la voce "+ voce.TITOLO +"?", () => {
                utils.ajax("theb/voci/delete", { ID_VOCE: voce.ID_VOCE }, (response) => {
                    if (response.esito == 0) {
                        utils.alert.success("Voce eliminata con successo.");
                        this.getAttivita();
                        this.$emit('updateGriglia');
                    }
                });
            },this.$root);
        },

        ordineAttivitaChanged() {
            for (var i = 0; i < this.arrayAttivita.length; i++) {
                this.arrayAttivita[i]['ORDINE'] = (i + 1);
            }
            utils.ajax("theb/attivita/ordine", {
                array: this.arrayAttivita,
                ID_PROGETTO: this.progetto.ID_PROGETTO
            }, (response) => {
                if (response.esito == 0) {
                    utils.alert.success("Ordine attività salvato con successo.");
                }
            });
        },

        getCittaProgetto() {
            utils.ajax("theb/progetto/citta", { ID_PROGETTO: this.progetto.ID_PROGETTO }, (response) => {
                this.cittaProgetto = response.data || [];
            });
        },

        ordineVociChanged(attivita) {
            for (var i = 0; i < attivita.VOCI.length; i++) {
                attivita.VOCI[i]['ORDINE'] = (i + 1);
            }
            utils.ajax("theb/voci/ordine", {
                array: attivita.VOCI,
                ID_ATTIVITA: attivita.ID_ATTIVITA
            }, (response) => {
                if (response.esito == 0) {
                    utils.alert.success("Ordine voci salvato con successo.");
                }
            });
        },
    }
}
</script>
